
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    AppLanguage: () => import("@/app/modules/settings/components/AppLanguage.vue")
  }
})
export default class SettingsPage extends Vue {}
